// src/pages/produtos/produtos/GeralTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import { useConfigModulo } from '../../../contexts/administrativo/ConfigModuloContext';
import { useGrupo } from '../../../contexts/produtos/GrupoContext';
import { useSubGrupo } from '../../../contexts/produtos/SubGrupoContext';
import { useMarca } from '../../../contexts/produtos/MarcaContext';
import { useUnMedida } from '../../../contexts/produtos/UnMedidaContext';
import { Grupo } from '../../../models/produtos/Grupo';
import { SubGrupo } from '../../../models/produtos/SubGrupo';
import { Marca } from '../../../models/produtos/Marca';
import { UnMedida } from '../../../models/produtos/UnMedida';
import GrupoSearch from '../grupos/GrupoSearch';
import GrupoCad from '../grupos/GrupoCad';
import SubGrupoSearch from '../subGrupos/SubGrupoSearch';
import SubGrupoCad from '../subGrupos/SubGrupoCad';
import MarcaSearch from '../marcas/MarcaSearch';
import MarcaCad from '../marcas/MarcaCad';
import UnMedidaSearch from '../unMedida/UnMedidaSearch';
import UnMedidaCad from '../unMedida/UnMedidaCad';
import ModalPrecosProduto from './ModalPrecosProduto';
import { FaDollarSign, FaEdit } from 'react-icons/fa'; // ✅ Ícone de edição
import { formatNumeric } from '../../../utils/numberUtils';
import './GeralTab.css';



const GeralTab = ({
    produto,
    setProduto,
    disableCampos,
}) => {

    const { grupos } = useGrupo();
    const { subGrupos } = useSubGrupo();
    const { marcas } = useMarca();    
    const { unMedidas } = useUnMedida();
    const { configModuloSel } = useConfigModulo();
    
    const [showSearchGrupo, setShowSearchGrupo] = useState(false);
    const [showCadGrupo, setShowCadGrupo] = useState(false);
    const [showSearchSubGrupo, setShowSearchSubGrupo] = useState(false);
    const [showCadSubGrupo, setShowCadSubGrupo] = useState(false);
    const [showSearchMarca, setShowSearchMarca] = useState(false);
    const [showCadMarca, setShowCadMarca] = useState(false);  
    const [showSearchUnMedida, setShowSearchUnMedida] = useState(false);
    const [showCadUnMedida, setShowCadUnMedida] = useState(false);    
    const [isEditandoCusto, setIsEditandoCusto] = useState(false);
    const [showModalPrecosProduto, setShowModalPrecosProduto] = useState(false);

    useEffect(() => {
        setIsEditandoCusto(false);
    }, [produto.id]);

    const handleExitGrupo = (grupoId) => {
        const grupoSelecionado = grupos.find(g => g.id.toString() === grupoId.toString());        
        if (grupoSelecionado) {
            if (produto.Grupo?.id !== grupoId) {
                setProduto({ ...produto, grupo: grupoSelecionado, subGrupo: new SubGrupo(), subGrupoId: null });
            } else {
                setProduto({ ...produto, grupo: grupoSelecionado });
            }
        } else {
            setProduto({ ...produto, grupo: new Grupo() });
        }
    };

    const handleExitSubGrupo = (subGrupoId) => {
        const subGrupoSelecionado = subGrupos.find(g => g.id.toString() === subGrupoId.toString());        
        if (subGrupoSelecionado) {
            const grupoSelecionado = grupos.find(g => g.id.toString() === subGrupoSelecionado.grupoId.toString());
            setProduto({ ...produto, subGrupo: subGrupoSelecionado, grupo: grupoSelecionado});
        } else {
            setProduto({ ...produto, subGrupo: new SubGrupo() });
        }
    };

    const handleExitMarca = (marcaId) => {
        const marcaSelecionada = marcas.find(m => m.id.toString() === marcaId.toString());
        if (marcaSelecionada) {
            setProduto({ ...produto, marca: marcaSelecionada });
        } else {
            setProduto({ ...produto, marca: new Marca() });
        }
    };

    const handleExitUnMedida = (unMedidaSigla) => {
        const unMedidaSelecionada = unMedidas.find(u => u.sigla.toUpperCase() === unMedidaSigla.toUpperCase());
        if (unMedidaSelecionada) {
            setProduto({ ...produto, unMedida: unMedidaSelecionada });
        } else {    
            setProduto({ ...produto, unMedida: new UnMedida() });
        }
    };

    const handleSelectGrupo = (grupo) => {
        if (produto.Grupo?.id !== grupo.id) {
            setProduto({ ...produto, grupo, subGrupo: new SubGrupo(), subGrupoId: null });
        } else {
            setProduto({ ...produto, grupo });
        }        
        setShowSearchGrupo(false);
    };

    const handleSelectSubGrupo = (subGrupo) => {
        const grupoSelecionado = grupos.find(g => g.id.toString() === subGrupo.grupoId.toString());
        setProduto({ ...produto, subGrupo, grupo: grupoSelecionado });
        setShowSearchSubGrupo(false);
    };

    const handleSelectMarca = (marca) => {
        setProduto({ ...produto, marca });
        setShowSearchMarca(false);
    };

    const handleSelectUnMedida = (unMedida) => {
        setProduto({ ...produto, unMedida });
        setShowSearchUnMedida(false);
    };

    return (
        <div className="produto-geral-tab">
            <div className="input-group">                                
                <Input
                    label="Grupo"
                    value={produto.grupo?.id || ''}                                                
                    onChange={(e) => setProduto({ 
                        ...produto, 
                        grupo: { 
                            ...produto.grupo,
                            id: e.target.value 
                        }
                    })}
                    onBlur={(e) => handleExitGrupo(e.target.value)}
                    btnBuscar={() => setShowSearchGrupo(true)}
                    btnAdd={() => setShowCadGrupo(true)}
                    size={80}
                />   
                <Input
                    value={produto.grupo?.descricao || ''}                                        
                    size={300}
                    disabled                                  
                /> 
            </div>
            <div className="input-group">                                
                <Input
                    label="Sub-grupo"
                    value={produto.subGrupo?.id || ''}                                                
                    onChange={(e) => setProduto({ 
                        ...produto, 
                        subGrupo: { 
                            ...produto.subGrupo,
                            id: e.target.value 
                        }
                    })}
                    onBlur={(e) => handleExitSubGrupo(e.target.value)}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                    btnAddDisabled={disableCampos}
                    btnBuscar={() => setShowSearchSubGrupo(true)}
                    btnAdd={() => setShowCadSubGrupo(true)}
                    size={80}
                />   
                <Input
                    value={produto.subGrupo?.descricao || ''}                                        
                    size={300}
                    disabled                                  
                /> 
            </div>
            <div className="input-group">
                <Input
                    label="Marca/Fabr."
                    value={produto.marca?.id || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        marca: {
                            ...produto.marca,
                            id: e.target.value
                        }
                    })}
                    onBlur={(e) => handleExitMarca(e.target.value)}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                    btnAddDisabled={disableCampos}
                    btnBuscar={() => setShowSearchMarca(true)}
                    btnAdd={() => setShowCadMarca(true)}
                    size={80}
                />    
                <Input
                    value={produto.marca?.descricao || ''}                                        
                    size={300}
                    disabled                                  
                />                                                                                                   
            </div>
            <div className="input-group">
                <Input
                    label="Un. Medida"
                    value={produto.unMedida?.sigla || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        unMedida: {
                            ...produto.unMedida,
                            sigla: e.target.value
                        }
                    })}
                    onBlur={(e) => handleExitUnMedida(e.target.value)}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                    btnAddDisabled={disableCampos}
                    btnBuscar={() => setShowSearchUnMedida(true)}
                    btnAdd={() => setShowCadUnMedida(true)}
                    size={60}
                />  
                <Input
                    value={produto.unMedida?.descricao || ''}                                        
                    size={100}
                    disabled  
                    style={{ marginRight: '20px' }}                              
                />  

                <div className="produto-campo-com-check">
                    <Input
                        label="Preço"
                        monetary
                        value={produto.preco ?? ''}
                        onChange={(e) => setProduto({ ...produto, preco: e.target.value })}
                        disabled={disableCampos}
                        type="text"
                        size={80}
                        style={{ textAlign: 'right' }}
                    />
                    {configModuloSel?.moduloPedido === true && (
                        <button
                            type="button"
                            className="produto-campo-acao"
                            onClick={() => setShowModalPrecosProduto(true)}
                            disabled={disableCampos || !produto?.id}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: disableCampos || !produto?.id ? 'not-allowed' : 'pointer',
                                padding: '4px',
                                color: disableCampos || !produto?.id ? '#94a3b8' : '#28a745',
                            }}
                            title={!produto?.id ? 'Salve o produto antes de cadastrar preços por horário' : 'Preços por horário'}
                        >
                            <FaDollarSign size={18} />
                        </button>
                    )}
                    <div>
                        <InputCheck
                            id="ehServico"
                            label="Serviço"
                            checked={produto.ehServico === true}
                            onChange={(e) => setProduto({
                                ...produto,
                                ehServico: e.target.checked,
                                movEstoque: e.target.checked ? false : produto.movEstoque,
                                estoqueMin: e.target.checked ? null : produto.estoqueMin
                            })}
                            disabled={disableCampos}
                        />
                    </div>
                </div>
                 {/* ✅ Campo de Custo com botão de edição */}
                <div className="produto-campo-com-check">
                    <Input
                    label="Custo"
                    value={produto.custoUltimo || ''}
                    onChange={(e) => {
                        let inputValue = e.target.value;
                        setProduto({ ...produto, custoUltimo: inputValue });
                    }}
                    onBlur={() => {
                        setProduto({ ...produto, custoUltimo: produto.custoUltimo ? formatNumeric(produto.custoUltimo) : null });
                    }}
                    disabled={disableCampos || !isEditandoCusto} // 👈 controla a edição
                    type="text"
                    size={80}
                    style={{ textAlign: 'right' }}
                    />

                    {/* Botão de edição */}
                    <button
                    type="button"
                    className="produto-campo-acao"
                    onClick={() => setIsEditandoCusto(!isEditandoCusto)}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        color: isEditandoCusto ? '#28a745' : '#007bff',
                    }}
                    title={isEditandoCusto ? 'Bloquear edição do custo' : 'Editar custo'}
                    >
                    <FaEdit size={18} />
                    </button>

                    <InputCheck
                        id="movEstoque"
                        label="Movimenta Estoque"
                        checked={produto.movEstoque !== false}
                        onChange={(e) => setProduto({
                            ...produto,
                            movEstoque: e.target.checked,
                            estoqueMin: e.target.checked ? produto.estoqueMin : null
                        })}
                        disabled={disableCampos}
                    />
                    {produto.movEstoque !== false && (
                        <Input
                            label="Estoque Min."
                            value={produto.estoqueMin || ''}
                            onChange={(e) => {                            
                                setProduto({ ...produto, estoqueMin: e.target.value });
                            }}
                            onBlur={() => {
                                setProduto({ ...produto, estoqueMin: formatNumeric(produto.estoqueMin) });
                            }}
                            disabled={disableCampos}
                            type="text"
                            size={80}
                            style={{ textAlign: 'right', marginRight: '20px' }}
                        />
                    )}
                </div>
                 
                {/* <Input
                    label="Est. Min."
                    value={produto.estoqueMin || ''}
                    onChange={(e) => setProduto({ ...produto, estoqueMin: e.target.value })}   
                    disabled={disableCampos}
                    type="number"
                    size={80}
                /> */}
                <InputCheck
                    id="alteraDescricao"
                    label="Altera Descrição na Venda"
                    checked={produto.alteraDescricao ?? false}
                    onChange={(e) => setProduto({ ...produto, alteraDescricao: e.target.checked })}   
                />
                <InputCheck
                    label="Preço Fixo"
                    checked={produto.precoFixo ?? false}
                    onChange={(e) => setProduto({ ...produto, precoFixo: e.target.checked })}   
                />
                <InputCheck
                    label="Inativo"
                    checked={produto.inativo ?? false}
                    onChange={(e) => setProduto({ ...produto, inativo: e.target.checked })}   
                />
                
            </div>   
            <GrupoSearch
                show={showSearchGrupo}
                onHide={() => setShowSearchGrupo(false)}
                onSelectGrupo={handleSelectGrupo}
            />
            <GrupoCad
                show={showCadGrupo}
                onHide={() => setShowCadGrupo(false)}
            />
            <SubGrupoSearch
                show={showSearchSubGrupo}
                onHide={() => setShowSearchSubGrupo(false)}                
                onSelectSubGrupo={handleSelectSubGrupo}
                grupoIdSel={produto.grupo?.id}
            />
            <SubGrupoCad
                show={showCadSubGrupo}
                onHide={() => setShowCadSubGrupo(false)}
            />
            <MarcaSearch
                show={showSearchMarca}
                onHide={() => setShowSearchMarca(false)}
                onSelectMarca={handleSelectMarca}
            />
            <MarcaCad
                show={showCadMarca}
                onHide={() => setShowCadMarca(false)}
            />
            <UnMedidaSearch
                show={showSearchUnMedida}
                onHide={() => setShowSearchUnMedida(false)}
                onSelectUnMedida={handleSelectUnMedida}
            />
            <UnMedidaCad
                show={showCadUnMedida}
                onHide={() => setShowCadUnMedida(false)}
            />                                       
        
            <ModalPrecosProduto
                show={showModalPrecosProduto}
                onHide={() => setShowModalPrecosProduto(false)}
                produto={produto}
            /></div>
    );
};

export default GeralTab;
